/* eslint-disable react/prop-types */
import React from "react";

/** Small badge reflecting milestone status */
function StatusBadge({ status = "planned" }) {
  const map = {
    done: "bg-green-500/20 text-green-300 border-green-400/50",
    "in-progress": "bg-fvyellow/20 text-fvyellow border-fvyellow/50",
    planned: "bg-white/10 text-white border-white/30",
  };
  const labelMap = { done: "Done", "in-progress": "In progress", planned: "Planned" };
  return (
    <span className={`text-xs border px-2 py-1 rounded-full tracking-wide ${map[status] || map.planned}`}>
      {labelMap[status] || "Planned"}
    </span>
  );
}

/**
 * LAOSTimeline (reusable)
 * props:
 * - items: [{ date, title, text, status?: 'planned'|'in-progress'|'done', link?: string }]
 * - headerTitle: string
 * - headerText:  string
 */
export default function LAOSTimeline({ items = [], headerTitle, headerText }) {
  return (
    <>
      {/* Header band */}
      {/* <section>
        <div className="bg-[radial-gradient(ellipse_at_bottom,_var(--tw-gradient-stops))] from-fvorange from-0% via-fvpurple to-fvmidpurple to-50% py-16">
          <div className="w-11/12 sm:w-2/3 mx-auto text-center">
            {headerTitle && <h2 className="text-fvyellow font-bold text-2xl sm:text-4xl">{headerTitle}</h2>}
            {headerText && <p className="mt-4 sm:text-lg opacity-90">{headerText}</p>}
          </div>
        </div>
      </section> */}

      {/* Timeline */}
      <section className="py-6">
        <h3 className="section-title text-3xl mb-2 text-center">Timeline</h3>
        <hr className="w-[15%] h-[2px] mt-4 mb-8 mx-auto rounded border-0 hr-colored" />

        <div className="relative container mx-auto px-6 md:px-12">
          {/* vertical line */}
          <div className="hidden md:block absolute left-1/2 top-0 -translate-x-1/2 h-full w-px bg-white/20" />

          <ol className="space-y-10">
            {items.map((m, i) => {
              const isLeft = i % 2 === 0;
              return (
                <li key={i} className="md:grid md:grid-cols-2 md:items-center md:gap-10">
                  {/* Card */}
                  <div className={`md:pr-10 ${isLeft ? "" : "md:order-2 md:pl-10"}`}>
                    <div className="md:hidden mb-3 text-sm uppercase tracking-wide opacity-80">{m.date}</div>

                    <div className="relative rounded-2xl p-5 md:p-6 bg-white/5 backdrop-blur-sm border border-white/10 shadow-lg">
                      {/* dot on center line (desktop) */}
                      <div
                        className={`hidden md:block absolute top-1/2 -translate-y-1/2 ${
                          isLeft ? "right-[-34px]" : "left-[-34px]"
                        }`}
                      >
                        <div className="w-6 h-6 rounded-full border-2 border-fvyellow bg-fvyellow/20 shadow-[0_0_0_4px_rgba(255,255,255,0.06)]" />
                      </div>

                      <div className="flex items-center gap-3 mb-2">
                        <StatusBadge status={m.status} />
                        <span className="hidden md:inline text-sm opacity-80">{m.date}</span>
                      </div>

                      <h4 className="text-xl font-semibold">{m.title}</h4>
                      <p className="mt-2 opacity-90">{m.text}</p>

                      {m.link && (
                        <div className="mt-4">
                          <a
                            href={m.link}
                            className="text-fvyellow border border-fvyellow px-4 py-2 rounded transition duration-300 ease-in-out hover:bg-fvyellow hover:text-fvpurple"
                          >
                            Learn more
                          </a>
                        </div>
                      )}
                    </div>
                  </div>

                  {/* Right column date (desktop only) */}
                  <div className={`${isLeft ? "md:order-2" : ""} hidden md:flex md:justify-center`}>
                    <div className="text-center">
                      <div className="inline-block rounded-full border border-white/20 px-4 py-2 text-sm tracking-wide opacity-80">
                        {m.date}
                      </div>
                    </div>
                  </div>
                </li>
              );
            })}
          </ol>
        </div>
      </section>
    </>
  );
}
